import * as React from 'react';
import axios from 'axios';
import { getShopRefInStorage } from '../mon-compte/MonCompteAction';
import { getHostApi, getRequestConfig } from '../../utils';
import Modal from "react-responsive-modal";
import {clearCart} from "./CartAction";
import RenderCodeReduction from "./RenderCodeReduction";
import {Cart} from "./iCart";
import { TranslationProps, WithTranslation } from "../../contexts/TranslationContext";

interface ShareCartProps extends TranslationProps {
  cartId: string;
  cart?: Cart
}

interface ShareCartState {
  visibleForm: boolean;
  linkShareCart: string;
  open: boolean;
}

class RenderShareCart extends React.Component<ShareCartProps, ShareCartState> {
  constructor(props: ShareCartProps) {
    super(props);
    this.state = {
      visibleForm: false,
      linkShareCart: '',
      open: false
    };
  }

  shareCart = () => {
    const i18nLangStr = localStorage.getItem('i18nLang');
    let idLang = 1;
    if (i18nLangStr) {
      const i18nLangObj = JSON.parse(i18nLangStr);
      idLang = i18nLangObj.id;
    }

    axios.post( getHostApi() + '/carts/' + this.props.cartId + '/share/', {}, {params: {idLang},...getRequestConfig()})
      .then((response) => {
        let link = response.data.link;
        if (window.location.hostname.includes('deixo.com')) {
          link = link.replace('lamaisonduteeshirt.com', 'deixo.com');
        }
        this.setState({
          linkShareCart: link,
          visibleForm: true,
        });
      }).catch((error) => {
        console.log(error);
      });
  }

  copyLink = () => {
    const linkCart : any = document.getElementById('linkCart');
    if (linkCart) {
      linkCart.select();
      document.execCommand('Copy');
      this.showNotif();
    }
  }

  activePrint = () => {

    window.print();
  }


  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  showNotif() {
    const notifShareCart = document.getElementById('notifShareCart');
    if (notifShareCart) {
      notifShareCart.style.visibility = 'visible';
      setTimeout(() => {
        notifShareCart.style.visibility = 'hidden';
      }, 4000);
    }
  }

  render() {
    const renderLinkShareCart = () => {
      if (getShopRefInStorage() !== 'ME' && getShopRefInStorage() !== 'DT') {
        return (
          <div  className="btnShareCart mr-md-4 mb-5 mb-md-0" onClick={this.shareCart}>
            <img src="/order/images/cart/ic_share_panier.png" height="18px" alt="" className="mr-1" />
            {this.props.textsContent['CART_SHARE']}
          </div>
        );
      }
    };

    const codePromo = () => {
      if(this.props.cart) {
        return (
          <div className="btnPromoCart d-flex align-items-center font11">
            <img src="/order/images/cart/ic_promo_code.png" height="22px" alt="" />
            <RenderCodeReduction
              remises={this.props.cart.remises}
              reduction={this.props.cart.reduction}
            />
          </div>
        );
      }
    }

    const renderFormShareCart = () => {
      return (
        <div id="formShareCart containerShareCart">
          <div className="font-weight-bold">{this.props.textsContent?.['CART_SHARE_EXPLAIN']}</div>
          <input type="text" id="linkCart" className="linkCart" value={this.state.linkShareCart}/>
          <button onClick={this.copyLink} className="copieBtn">{this.props.textsContent?.['CART_SHARE_COPY']}</button>
          <div id="notifShareCart notifCopie" className="notifCopie" style={{ visibility: 'hidden' }}>Le lien à été
                                                                                                    copié
          </div>
        </div>
      );
    };

    const renderPrintCart = () => {
      if (getShopRefInStorage() !== 'ME') {
        return (
          <div onClick={this.activePrint} className="btnShareCart mr-md-4 mb-5 mb-md-0">
            <img src="/order/images/cart/ic_print_panier.png" height={18} alt="" className="mr-1"/>
            {this.props.textsContent['CART_PRINT']}
          </div>
        );
      }
    };

    const renderClearCart = () => {
        return (
          <>
          <div  onClick={this.onOpenModal} className="btnShareCart mr-md-4 mb-5 mb-md-0">
            <img src="/order/images/cart/ic_delete_panier.png" height={18} alt="" className="mr-1"/>
            {this.props.textsContent['CART_DELETE_ALL']}
          </div>
          <Modal classNames={{ overlay: 'bootstrap-container' }} open={this.state.open} onClose={this.onCloseModal} center>
            <div className="p-5">
              <span dangerouslySetInnerHTML={{__html: this.props.textsContent['CART_TEXT_DELETE_CART']}}></span>
              <div className={'d-flex justify-content-center align-items-center mt-5'}>
                <button
                  className={'border  p-2 font18 px-4 mr-4 black  font-weight-bold text-center rounded '}
                  onClick={this.onCloseModal}
                >
                  {this.props.textsContent['CART_NO']}
                </button>
                <button
                  className={'border  p-2 font18 px-4 ml-4 black  font-weight-bold text-center rounded'}
                  onClick={clearCart}
                  >
                    {this.props.textsContent['CART_YES']}
                  </button>
              </div>
            </div>
          </Modal>
            </>
        );
    };

      return (
        <div className="d-flex justify-content-center flex-column flex-md-row justify-content-md-between align-items-md-center mt-5 mt-md-3 mb-md-2 order-3 order-md-1" >
          {renderClearCart()}
          {renderPrintCart()}
          {getShopRefInStorage() != 'ME' && this.state.visibleForm ? renderFormShareCart() : renderLinkShareCart()}
          {codePromo()}
        </div>
      );
  }
} export default WithTranslation(RenderShareCart, 'CART_TUNNEL')
